import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import { AffectedStaffSalariesListPage } from './affected-staff-salaries-list'
import AffectedStaffViewPage from './affected-staff-view'
import { AffectedStaffDiffusionsListPage } from './affected-staffs-diffusions-list'
import { AffectedStaffsListPage } from './affected-staffs-list'

const affectedStaffsRoutes: Route[] = [
  {
    path: Paths.AFFECTED_STAFFS_LIST_PAGE,
    element: <AffectedStaffsListPage />
  },
  {
    path: Paths.AFFECTED_STAFFS_VIEW_PAGE,
    element: <AffectedStaffViewPage />
  },
  {
    path: Paths.AFFECTED_STAFFS_SALARIES_LIST_PAGE,
    element: <AffectedStaffSalariesListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.AFFECTED_STAFF_DIFFUSIONS_LIST_PAGE,
    element: <AffectedStaffDiffusionsListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default affectedStaffsRoutes
